export function getStatusBadge(status) {
  const badges = {
    'pending': {
      class: 'badge-status badge-pending',
      icon: 'fas fa-clock',
      text: 'Pending'
    },
    'in_process': {
      class: 'badge-status badge-progress',
      icon: 'fas fa-spinner',
      text: 'In Process'
    },
    'under_action': {
      class: 'badge-status badge-action',
      icon: 'fas fa-tools',
      text: 'Under Action'
    },
    'under_verification': {
      class: 'badge-status badge-verification',
      icon: 'fas fa-check-circle',
      text: 'Under Verification'
    },
    'completed': {
      class: 'badge-status badge-completed',
      icon: 'fas fa-check-double',
      text: 'Completed'
    },
    'rejected': {
      class: 'badge-status badge-rejected',
      icon: 'fas fa-times-circle',
      text: 'Rejected'
    },
    'started': {
      class: 'badge-status badge-started',
      icon: 'fas fa-play-circle',
      text: 'Started'
    },
    'on_hold': {
      class: 'badge-status badge-onhold',
      icon: 'fas fa-pause-circle',
      text: 'On Hold'
    }
  }

  if (!status) {
    return `<span class="badge-status badge-pending" style="font-size: 10px;">
      <i class="fas fa-clock"></i> Pending
    </span>`
  }

  const badge = badges[status]
  if (!badge) {
    return `<span class="badge-status badge-default" style="font-size: 10px;">
      <i class="fas fa-circle"></i> ${status}
    </span>`
  }

  return `<span class="${badge.class}" style="font-size: 10px;">
    <i class="${badge.icon}"></i>
    ${badge.text}
  </span>`
}

export function getIssuesCount(schedule) {
  let str = "";
  if(schedule.corrective_actions_count ?? 0 > 0) {
    str += (schedule.corrective_actions_count ?? 0) + " Corrective Action(s)";
  }
  if(schedule.corrections_count ?? 0 > 0) {
    if(str.length > 0) {
      str += ", ";
    }
    str += (schedule.corrections_count ?? 0) + " Correction(s)";
  }
  if(str == "")
  {
    str = "---";
  }
  return str;
}